import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { AppState } from 'services/types';
import {
    VirtualizedTableItemValue,
    VirtualizedTableProps
} from 'services/virtualizedTable/types';
import { makeSelectVirtualizedTableItemValue } from 'services/virtualizedTable/selectors';
import StatusIcon from 'components/StatusIcon';
import {
    ERROR,
    IN_PROGRESS,
    MULTIPLE_GROUPS,
    OFFLINE_ONLY,
    SAVED_ONLINE,
    SUCCESS,
    UPDATING,
    UPLOAD_FAILED
} from 'components/StatusIcon/constants';

type OwnProps = VirtualizedTableProps;

interface ConnectedProps {
    value?: VirtualizedTableItemValue;
}

export type Props = OwnProps & ConnectedProps;

export class VirtualizedTableStatusIconComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement | null {
        const { value } = this.props;

        switch (value) {
            case SAVED_ONLINE:
            case OFFLINE_ONLY:
            case UPLOAD_FAILED:
            case UPDATING:
            case MULTIPLE_GROUPS:
            case IN_PROGRESS:
            case ERROR:
            case SUCCESS:
                return <StatusIcon status={value} />;
            default:
                return null;
        }
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    value: makeSelectVirtualizedTableItemValue()
});

export default connect(mapStateToProps)(VirtualizedTableStatusIconComponent);
